import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-table-header-group',
  standalone: true,
  imports: [],
  templateUrl: './table-header-group.component.html',
  styleUrl: './table-header-group.component.scss'
})
export class TableHeaderGroupComponent {}
